import styled from 'styled-components';

export {
  BoxContainer,
  CheckContainer,
} from 'styles/styled-components';

export const Title = styled.h3`
  margin-bottom: 16px;
  display: block;
`;
